const messages = {
  product_title: 'Messenger Service',
  sign_in: 'Sign in',
  signing_in: 'Please wait...',
  staff_login: 'Staff Login',
  or_divider: 'OR',
  email_placeholder: 'Username',
  password_placeholder: 'Password',
  show_password: 'Show password',
  hide_password: 'Hide password',
  logo_alt: 'Roommatik Logo',
  errors: {
    invalid_credentials: 'Invalid email or password.',
    google_unavailable: 'Google sign-in is not available right now.',
    google_missing_email: 'Google account did not provide an email address.',
    generic: 'Sign-in failed. Please try again.',
  },
};

export default messages;
